import React from 'react'
import { useTranslation } from 'react-i18next'
import { Profile } from '../../types/profile'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

interface deleteDialogProps {
  profiles: Profile[]
  onConfirm: () => void
  onClose: () => void
}
const DeleteDialog = (props: deleteDialogProps) => {
  const { t } = useTranslation()
  const profiles = props.profiles?.map((p) => p.name).join(', ')
  return (
    <Dialog open={true}>
      <DialogTitle>
        <Typography variant="h5" sx={{ display: 'flex', justifyContent: 'space-between', m: 1 }}>
          {t('common.delete')}
          <IconButton onClick={props.onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Typography>
      </DialogTitle>
      <DialogContent
        sx={{
          borderTop: 1,
          borderBottom: 1,
          borderColor: 'secondary.light',
        }}
      >
        <Typography sx={{ m: 2 }}>{t('common.deleteconfirmation').replace('{0}', profiles)}</Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'space-between', m: 1 }}>
        <Button variant="contained" onClick={props.onClose}>
          {t('common.cancel')}
        </Button>
        <Button color="error" variant="contained" onClick={props.onConfirm}>
          {t('common.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
export default DeleteDialog
